export const GUARDS = {
  AdminGuard: 'AdminGuard',
  DirectionGuard: 'DirectionGuard',
  OperationsGuard: 'OperationsGuard',
  ManagerGuard: 'ManagerGuard',
  AdvisoryGuard: 'AdvisoryGuard',
  EmployeeGuard: 'EmployeeGuard'
};
